// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ok_a bhe_qr bhe_a bhe_w","FaqAskQuestion__outdated":"ok_b bhe_vp bhe_xe"};